<template>
  <div class='view'>
    <top-nav @menu_data="getMenuData" />
    <div class="blank70"></div>
    <div class="pricings">
      <div class="titles">
        {{ $t("pricing.choose_the_plan") }}
      </div>

      <!-- <el-tabs v-model="value" type="border-card" class="billing-tabs">
        <el-tab-pane :label="$t('pricing.monthly')" name="first" />
        <el-tab-pane name="second">
          <span slot="label">
            {{ $t('pricing.yearly') }}
            <span class="save-badge">{{ $t('pricing.save_up_to') }}</span>
          </span>
        </el-tab-pane>
      </el-tabs> -->

      <el-tabs type="border-card" class="tabsstyle" v-model="value"> 
        <el-tab-pane :label="$t('pricing.monthly')" name="first">
        </el-tab-pane>
        <el-tab-pane name="second">
          <span slot="label" class="">
            {{ $t('pricing.yearly') }}
            <span class="save-badge">{{  $t('pricing.save_up_to') }}</span>
          </span>
        </el-tab-pane>        
      </el-tabs>
      <div class="pricings_items" v-for="(d,i) in pricelist" :key="i">
        <div v-if="d.ishot" class="most_popular_badge">
          <p>{{ $t('pricing.most_popular') }}</p>
        </div>
        <div class="price_tab" :class="{'price_tab_background':d.ishot}" :style="d.topStyle">
          <div class="main_title">
            <p class="pricings_items_title">{{d.title}}</p>
            <p class="contents_item_object" :class="[isID?'IDcontents_item_object':'']">{{d.object}}</p>
          </div>
          <div class="contents_item_price">
            <div class="price-section" :class="value == 'second'? '' : 'is-month'">                    
              <p class="price"> 
                {{value == 'second' ? d.yearPrice: d.monthPrice}}
              </p>
              <div v-if="value == 'second'">
                <p class="desc">{{ d.yearPriceDesc1 }}</p>
                <p class="desc">{{ d.yearPriceDesc2 }}</p>
              </div>  
              <div v-else>
                <p class="month-desc">{{ $t('pricing.seat_per_month') }}</p>
              </div> 
            </div>  
            <div class="save-badge" v-if="value == 'second'">
              <p>{{ d.savePrice }}</p>
            </div> 
            <div class="seats_number">
              <p>{{ d.seats }}</p>
              <p>{{ d.seatDesc }}</p>
            </div>  
          </div> 
          <div class="book_a_demo" :class="[isID?'IDbook_a_demo':'']"  @click="handleDemoBooking(true)">{{ $t("home.book_for_free") }}</div>
          <div class="package-plan">                  
            <div class="plan-desc">
              <p>{{ d.placDesc }}</p>
              <p v-if="d.placDesc2">{{ d.placDesc2 }}</p>
            </div>
          </div>
          <div class="pricings_items_plans">
            <span>{{d.plans}}</span>
            <img @click="handleShowAdditioinal(d.title)" :class="{'rotates':isShowAdditionalTab[d.title]}" src="../../assets/imgs/app/feature/down.png" alt="">
          </div>
          <div class="show_additional_price" v-if="isShowAdditionalTab[d.title]">
            <p class="additional_service_item" v-for="(dd,j) in d.planlist" :key="j">
              <img class="icon" src="@/assets/svg/tick.svg" alt="bullet"/>
              <!-- <span class="additional_service_item_title">{{dd.title}}</span> -->
              <span class="additional_service_item_title"> 
                <img v-if="dd.textIcon" class="text-icon" :src="require(`@/assets/svg/${dd.textIcon}.svg`)" :alt=dd.textIcon />
                <span :class="[{'enhance-text': dd.textIcon, 'redirect-text': dd.redirect}]" @click="dd.redirect && goRouter(dd.redirect)">{{dd.title}}</span>
                <!-- <span :class="dd.textIcon ? 'enhance-text' : ''" @click="d.redirect && goRouter(d.redirect)">{{dd.title}}</span> -->
              </span>
              <img class="icon" src="@/assets/imgs/pc/pricing/info.png" v-if="dd.infoContent.length" @click="open(dd.infoContent)" alt="">
            </p>
          </div>
        </div>
      </div>
      
      <!-- <div class="additional_price_tab ">
        <p class="additional_service_title">Additional Service</p>
        <p class="additional_price_item" v-for="(dd,i) in additionall_planlist" :key="i">
          <span>{{dd.title}}</span>
          <img src="@/assets/imgs/pc/pricing/info.png" v-if="dd.infoContent.length" @click="open(dd.infoContent)" alt="">
        </p>
      </div> -->
    </div>
    <footer-nav />
    <menu-bar :isShow="isShow" @changeIsShow="changeShow" />
    <el-drawer title="Feature details" :visible.sync="drawer" direction="btt">
      <p v-for="(d,i) in datas" :key="i">{{d}}</p>
    </el-drawer>
    <book-demo v-if="showBookingDialog" :show="showBookingDialog" @update:show="handleDemoBooking"></book-demo>
  </div>
</template>
<script>
export default {
  components: {
    "top-nav": resolve => require(["./TopNav.vue"], resolve),
    "footer-nav": resolve => require(["./FooterNav.vue"], resolve),
    "menu-bar": resolve => require(["./MenuBar.vue"], resolve),
    "book-demo": () => import("./BookDemo/Index.vue")
  },
  data() {
    return {
      value:"second",
      isID:false,
      drawer: false,
      showBookingDialog: false,
      pricelist: [
        // {
        //   title: this.$t("pricing.solo"),
        //   monthPrice: this.$t("pricing.month_solo_price"),
        //   yearPrice: this.$t("pricing.year_solo_price"),
        //   object: this.$t("pricing.for_agent"),
        //   seats: this.$t("pricing.up_to_3"),
        //   plans: this.$t("pricing.solo_plan_includes"),
        //   topStyle:{borderTop: '1px solid #e6ebf2'},
        //   planlist: [
        //     {
        //       id: 'a1',
        //       title: this.$t("pricing.arcanite"),
        //       infoContent: []
        //     },
        //     {
        //       id: 'a2',
        //       title: this.$t("pricing.arcanite_mobile"),
        //       infoContent: []
        //     },
        //     {
        //       id: 'a3',
        //       title: this.$t("pricing.arcanite_connect"),
        //       infoContent: []
        //     }, {
        //       id: 'a4',
        //       title: this.$t("pricing.basic_integrations"),
        //       infoContent: []
        //     },
        //     {
        //       id: 'a5',
        //       title: this.$t("pricing.connect_to_marketplace_title"),
        //       infoContent: []
        //     },
        //     {
        //       id: 'a6',
        //       title: this.$t("pricing.up_to_3_front_end"),
        //       infoContent: []
        //     },
        //     {
        //       id: 'a7',
        //       title: this.$t("pricing.supports_up_to_30_projects"),
        //       infoContent: ["Project data support is an on-demand service, which will incur additional charges"]
        //     }
        //   ],
        //   link: "https://meetings.hubspot.com/william463?embed=true",
        //   IDlink:"https://calendly.com/erni-yap",
        //   service: "Project Data Support Service",
        //   service_start: "(Starts at $100/month)",
        //   servicelist: [
        //     "Apartment - once per week",
        //     "Townhouse Project - twice per week",
        //     "House and Land Project - daily",
        //     "Number of projects supported - 30 / 50 / 80 / 200",
        //     "Additional Projects ($10/project/month)"
        //   ],
        //   ishot: false
        // },
        {
          title: this.$t("pricing.team"),
          monthPrice: this.$t("pricing.month_team_price"),
          yearPrice: this.$t("pricing.year_team_price"),
          yearPriceDesc1: this.$t("pricing.year_team_price") + this.$t("pricing.seat_per_month"),
          yearPriceDesc2: this.$t("pricing.year_team_year_price") + this.$t("pricing.seat_per_year"),
          savePrice: `A$72/${this.$t('pricing.seat_annual_save')}`,
          object: this.$t("pricing.for_agent"),
          seats: this.$t("pricing.minimum_10_seat"),
          seatDesc: this.$t("pricing.best_for_small_team"),
          placDesc: this.$t("pricing.team_package_desc"),
          placDesc2: "",
          plans: this.$t("pricing.everything_in_team_plus"),
          planlist: [
            {
              id: 'b1',
              title: this.$t("pricing.weekly_report_feature"),
              infoContent: [
                "Based on a standard set of data metrics"
              ]
            },
            {
              id: 'b2',
              title: this.$t("pricing.data_gathering_via_short_survey_links"),
              infoContent: ["Up to 5 survey links"]
            },
            {
              id: 'b3',
              title: this.$t("pricing.project_sharing_and_affiliations"),
              infoContent: ["Requires digital handshake via Arcanite Connect"]
            },
            // {
            //   id: 'b4',
            //   title: this.$t("pricing.data_support"),
            //   infoContent: []
            // },
            {
              id: 'b5',
              title: this.$t("pricing.starts_from_5_front_end_seats"),
              infoContent: []
            }
          ],
          link: "https://meetings.hubspot.com/william463?embed=true",
          IDlink:"https://.com/erni-yap",
          service: "Project Data Support Service",
          service_start: "(Starts at $100/month)",
          servicelist: [
            "Apartment - once per week",
            "Townhouse Project - twice per week",
            "House and Land Project - daily",
            "Number of projects supported - 30 / 50 / 80 / 200",
            "Additional Projects ($10/project/month)"
          ],
          ishot: false
        },
        {
          title: this.$t("pricing.pro"),
          monthPrice: this.$t("pricing.month_pro_price"),
          yearPrice: this.$t("pricing.year_pro_price"),
          yearPriceDesc1: this.$t("pricing.year_pro_price") + this.$t("pricing.seat_per_month"),
          yearPriceDesc2: this.$t("pricing.year_pro_year_price") + this.$t("pricing.seat_per_year"),
          savePrice: `A$60/${this.$t('pricing.seat_annual_save')}`,
          object: this.$t("pricing.for_developer_agent"),
          seats: this.$t("pricing.minimum_30_seat"),
          seatDesc: this.$t("pricing.best_for_scale"),
          placDesc: this.$t("pricing.pro_package_desc"),
          placDesc2: this.$t("pricing.pro_package_desc2"),
          plans: this.$t("pricing.everything_in_pro_plus"),
          planlist: [
            {
              id: 'c1',
              title: this.$t("pricing.basic_integrations"),
              infoContent: []
            },
            {
              id: 'c2',
              title: this.$t("pricing.web_apis"),
              infoContent: []
            },
            {
              id: 'c3',
              title: this.$t("pricing.advanced_reporting"),
              infoContent: []
            }, {
              id: 'c4',
              title: this.$t("pricing.starts_from_30_front_end_seats"),
              infoContent: []
            },
            // {
            //   id: 'c5',
            //   title: "Up to 30 front end seats",
            //   infoContent: []
            // },
            // {
            //   id: 'c6',
            //   title: "Support up to 80 projects",
            //   infoContent: ["Project data support is an on-demand service, which will incur additional charges"]
            // }
          ],
          link: "https://meetings.hubspot.com/william463?embed=true",
          IDlink:"https://calendly.com/erni-yap",
          service: "Project Data Support Service",
          service_start: "(Starts at $100/month)",
          servicelist: [
            "Apartment - once per week",
            "Townhouse Project - twice per week",
            "House and Land Project - daily",
            "Number of projects supported - 30 / 50 / 80 / 200",
            "Additional Projects ($10/project/month)"
          ],
          ishot: true
        },
        {
          title: this.$t("pricing.enterprise"),
          monthPrice: this.$t("pricing.month_enterprise_price"),
          yearPrice: this.$t("pricing.year_enterprise_price"),
          yearPriceDesc1: this.$t("pricing.year_enterprise_price") + this.$t("pricing.seat_per_month"),
          yearPriceDesc2: this.$t("pricing.year_enterprise_year_price") + this.$t("pricing.seat_per_year"),          
          savePrice: `A$72/${this.$t('pricing.seat_annual_save')}`,
          object: this.$t("pricing.for_developer"),
          seats: this.$t("pricing.unlimited_seat"),
          seatDesc: this.$t("pricing.custom_enterprise"),
          placDesc: this.$t("pricing.enterprise_package_desc"),
          placDesc2: "",
          plans: this.$t("pricing.everything_in_enterprice"),
          topStyle:{marginBottom: '20px'},
          planlist: [
            {
              id: 'd6',
              title: this.$t("pricing.vr_for_off_the_plan_projects"),
              infoContent: [],
              textIcon: 'dragonVR',
              redirect: '/DragonVR'
            },
            {
              id: 'd1',
              title: this.$t("pricing.customised_admin_dashboard"),
              infoContent: []
            },
            {
              id: 'd2',
              title: this.$t("pricing.customised_permissions"),
              infoContent: []
            },
            {
              id: 'd3',
              title: this.$t("pricing.customised_sales_workflows"),
              infoContent: []
            }, {
              id: 'd4',
              title: this.$t("pricing.multi_office_support_features"),
              infoContent: []
            },
            {
              id: 'd5',
              title: this.$t("pricing.master_data_tracking_and_reporting"),
              infoContent: ["Customisation in reporting may incur longer onboarding time"]
            },
            // {
            //   id: 'd6',
            //   title: "Equimate access",
            //   infoContent: ["Subject to accreditations"]
            // },
            // {
            //   id: 'd6',
            //   title: this.$t("pricing.vr_for_off_the_plan_projects"),
            //   infoContent: []
            // },
            // {
            //   id: 'd7',
            //   title: this.$t("pricing.starts_from_200_front_end_users"),
            //   infoContent: []
            // },
            // {
            //   id: 'd8',
            //   title: "Support up to 200 projects",
            //   infoContent: ["Project data support is an on-demand service, which will incur additional charges"]
            // }
          ],
          link: "https://meetings.hubspot.com/william463?embed=true",
          IDlink:"https://calendly.com/erni-yap",
          service: "Project Data Support Service",
          service_start: "(Starts at $100/month)",
          servicelist: [
            "Apartment - once per week",
            "Townhouse Project - twice per week",
            "House and Land Project - daily",
            "Number of projects supported - 30 / 50 / 80 / 200",
            "Additional Projects ($10/project/month)"
          ],
          ishot: false
        },
      ],
      datas: [],
      isShowAdditionalTab: {},
      isShow: false,
      additionall_planlist: [
        {
          id: 'a1',
          title: "Project Data Support Service (Starts at $100/month)",
          infoContent: []
        },
        {
          id: 'a2',
          title: "Apartment - once per week",
          infoContent: []
        },
        {
          id: 'a3',
          title: "Townhouse Project - twice per week",
          infoContent: []
        }, {
          id: 'a4',
          title: "House and Land Project - daily",
          infoContent: []
        },
        {
          id: 'a5',
          title: "Number of projects supported - 30 / 50 / 80 / 200",
          infoContent: ["Number of projects supported - 30 / 50 / 80 / 200"]
        },
        {
          id: 'a6',
          title: "Additional Projects ($10/project/month)",
          infoContent: []
        },
        {
          id: 'a7',
          title: "Supports up to 30 projects",
          infoContent: ["Project data support is an on-demand service, which will incur additional charges"]
        }
      ],
    };
  },

  computed: {},
  watch: {},
  methods: {
    goRouter(path) {
      const socialmedia = localStorage.getItem('socialmedia');
      const newPath = path + (socialmedia != '' ? `/${socialmedia}` : '/');
      this.$router.push({ path: newPath });
    },
    handleShowAdditioinal(title) {
      this.isShowAdditionalTab[title] = !this.isShowAdditionalTab[title]
      this.isShowAdditionalTab = Object.assign({}, this.isShowAdditionalTab)
    },
    handleDemoBooking(open = false) {
      const base = this.$route.path.replace(/\/bookdemo.*$/, '').replace(/\/$/, '');
      if (open) {
        history.pushState({ popup: 'open' }, '', `${base}/bookdemo`);
      } else {
        history.replaceState({}, '', base || '/');
      }
      this.showBookingDialog = open;
    },
    // showPopupWidget(d) {
    //   if(this.isID){
    //     Calendly.showPopupWidget(d.IDlink);
    //   }else{
    //     Calendly.showPopupWidget(d.link);
    //   }
    //   return false;
    // },
    getMenuData(val) {
      val == "1" ? (this.isShow = true) : (this.isShow = false);
    },
    changeShow() {
      this.isShow = false;
    },
    open(abc) {
      this.datas = abc
      this.drawer = true
      // let a =datas.join()
      // this.$alert(a, '', {
      //   showClose: false,
      //   lockScroll: true,
      //   showConfirmButton: false,
      //   showCancelButton: false,
      //   closeOnClickModal: true
      // });
    }
  },
  created() {
    if(localStorage.getItem('country')=="id"){
      this.isID=true;
    }else{
      this.isID=false;
    }
    this.pricelist.forEach(e => {
      this.isShowAdditionalTab[e.title] = false
    })
  }
}
</script>
<style lang='scss' scoped>
.view {
  background-color: #fff;
  .blank70 {
    height: 70px;
  }
  .pricings {
    padding-top: 24px;
    background-color: #fff;
    .show_additional_price {
      .additional_service {
        font-family: Poppins-Bold;
        font-size: 16px;
        // font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: left;
        color: #314455;
      }
      .additional_service_item {
        margin-top: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 12px;
        // p {
        //   font-size: 14px;
        //   font-weight: 500;
        //   line-height: 20px;
        //   text-align: left;
        //   color: #475569;
        // }
        span {
          display: flex;
          text-align: left;
          align-items: center;
          gap: 4px;
          >span {
            color: #475569;
            font-size: 14px;
            font-weight: 500;
            line-height: 20px; 
          }
          .enhance-text {
            color: #096DD9;
          }
          .redirect-text {
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .icon {
          width: 16px;
          height: 16px;
        }
        .text-icon {
          width: 20px;
          height: 20px;
        }
      }
    }
    .titles {
      font-family: Poppins-Bold;
      font-size: 26px;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.2;
      letter-spacing: normal;
      text-align: center;
      color: #062440;
      margin: 0 26px 14px 26px;
    }
    .pricings_items {
      position: relative;
      .ishot_badge {
        position: absolute;
        bottom: -17px;
        width: 124px;
        height: 36px;
        left: 50%; 
        transform: translateX(-50%); /* 50%为自身尺寸的一半 */
        -webkit-transform: translateX(-50%);
        img {
          width: 100%;
          height: 100%;
        }
      }
      .price_tab {
        border: 1px solid #e6ebf2;
        // border-top: 0px;
        margin-left: 22px;
        margin-right: 30px;
        padding: 10px 10px 30px 10px;
        box-sizing: border-box;
        border-radius: 5px;
        margin-bottom: 24px;
        position: relative;
        .main_title{
          display: flex;
          flex-direction: row;
          justify-content: space-between
        }
        .pricings_items_title {
          font-family: Poppins-Bold;
          font-size: 16px;
          // font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 22px;
          letter-spacing: normal;
          text-align: left;
          color: #062440;
        }
        .contents_item_object{
      
          color: #314455;
          border-radius: 9999px;
          background: #F1F5F9;
          padding: 4px 12px;
          text-transform: uppercase;

          font-size: 11px;
          font-weight: 600;
          line-height: 16.5px;
          letter-spacing: 0.55px;
        }
        .IDcontents_item_object{
          font-size: 12.8px;
        }
        .pricings_items_price {
          margin-top: 10px;
          font-family: Poppins-Bold;
          font-size: 26px;
          // font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.23;
          letter-spacing: normal;
          text-align: left;
          color: #062440;
          span {
            font-family: Poppins;
            font-size: 12px;
            font-weight: normal;
            line-height: 1.5;
            color: #67788c;
          }
        }
        .contents_paid_annually{
          text-align: left;
          font-family: Poppins;
          font-size: 12px;
          font-weight: normal;
          line-height: 1.5;
          color: #67788c;
        }
        .pricings_items_seats {
          margin-top: 20px;
          font-family: Poppins;
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.5;
          letter-spacing: normal;
          text-align: left;
          color: #314455;
          padding-bottom: 10px;
          border-bottom: 1px solid #e6ebf2;
        }
        .book_a_demo {
          font-family: Poppins-Bold;
          width: fit-content;
          padding: 10px 16px;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
          border: 1px solid #1890FF;
          color: #1890FF;
          font-size: 16px;
          font-family: Poppins-Bold;
          line-height: 22px;
          &:hover {
            cursor: pointer;
            background-color: #1890ff;
            color: #fff;
          }
          &:active{
            background-color: #0757ae;
          }
        }        
        .package-plan {
          padding-top: 10px;
          .plan-desc {
            text-align: left;
            >p:nth-child(1) {
              color: #062440;
              font-size: 14px;
              font-weight: 500;
              line-height: 24.38px; 
            }
            >p:nth-child(2) {
              color: #94A3B8;
              font-size: 11px;
              font-weight: 400;
              line-height: 16.5px;
            }
            padding-bottom: 20px;
            border-bottom: 1px solid #E6EBF2;
          }      
        }

        .IDbook_a_demo{
          width: 180px;
        }
        .pricings_items_plans {
          display: flex;
          justify-content: space-between;
          margin-top: 22px;
   
          span {
            color: #94A3B8;
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
            text-transform: uppercase;
          }
          img {
            width: 24px;
            height: 24px;
          }
        }
      }
      .contents_item_price {
        padding: 10px 0px;
        display: flex;
        flex-direction: column;
        gap: 11px;
        
        .price-section {
          display: flex;
          align-items: center;
          justify-content: space-between;
       
          .price {
            color: #062440;
            font-size: 26px;
            font-family: Poppins-Bold;
            line-height: 32px;
          }
          .desc {
            color: #515151;
            font-size: 12px;
            font-weight: 400;
            line-height: 21px;
          }
          .month-desc {
            color: #314455;
            font-size: 15px;
            font-weight: 500;
            line-height: 22.5px; 
          }
        } 
        .is-month {
          justify-content: flex-start;
          gap: 12px;
        }
        .save-badge {
          border-radius: 9999px;
          background: #DCF5E7;
          padding: 6px 16px;
          text-align: center;
          width: fit-content;
  
          border: 1px solid transparent;
          background-clip: padding-box, border-box;
          background-origin: border-box;
          background-image:
            linear-gradient(to bottom, #E0FDDE, #DCF5E7), /* inner bg */
            linear-gradient(to bottom, #E0FDDE, #7FDBAC); /* border gradient */
          box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.10), 0 4px 4px 0 #E0FEDD inset; 
          >p {
            color: #12B571;
            font-size: 11px;
            font-weight: 600;
            line-height: 16.5px; 
            letter-spacing: 0.55px;
            text-transform: uppercase;
          }
        }
        .seats_number {
          text-align: left;
          padding-bottom: 20px;
          >p:nth-child(1) {
            color: #314455;
            font-size: 13px;
            font-weight: 500;
            line-height: 19.5px; 
          }
          >p:nth-child(2) {
            padding-top: 4px;
            color: #94A3B8;
            font-size: 11px;
            font-weight: 400;
            line-height: 16.5px;
          }
        } 
      }
      .display_none_click {
        display: block;
      }
      .price_tab_background {
        background-color: #eef7ff;
        border: solid 1px #1890ff;
        .contents_item_object {
          background: #FFF;
          color: #1890FF;
        }
        .seats_number {
          text-align: left;
          >p:nth-child(1) {
            color: #64748B !important;
          }
          >p:nth-child(2) {
            padding-top: 8px;
            font-weight: 600 !important;
            color: #1890FF !important;
            text-transform: uppercase;
          }
        }
        .book_a_demo {
          font-family: Poppins;
          font-weight: 500;
          background-color: #1890FF;
          box-shadow: 0 4px 8px 0 rgba(24, 144, 255, 0.12), 0 0 8px 0 rgba(255, 255, 255, 0.12) inset;
          color: white !important;
          &:hover {
            cursor: pointer;
            background-color: #0757ae !important;
          }
        }
      }
      .most_popular_badge {
        position: absolute;
        border-radius: 5px;
        padding: 6px 12px;
        left: 50%;
        bottom: -16px; 
        z-index: 3;
        transform: translateX(-50%);
        background-color: #1890FF;
        >p {        
          color: white;
          font-size: 16px;
          font-weight: 600;
          line-height: 26px;
        }
      }
    }
    .rotates {
      transform: rotate(180deg);
    }
    .additional_price_tab {
      .additional_service_title {
        font-family: Poppins-Bold;
        font-size: 16px;
        // font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.38;
        letter-spacing: normal;
        text-align: left;
        color: #314455;
        padding-bottom: 10px;
      }
      border: 1px solid #e6ebf2;
      margin-left: 22px;
      margin-right: 30px;
      padding: 20px;
      box-sizing: border-box;
      border-radius: 5px;
      margin-bottom: 20px;
      transition: all 0.5s ease;
      .additional_price_item {
        display: flex;
        align-items: center;
        span {
          font-family: Poppins;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.71;
          letter-spacing: normal;
          text-align: left;
          color: #314455;
        }
        img {
          margin-left: 10px;
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
</style>
<style lang='scss'>
.el-message-box {
  width: 300px;
}
#el-drawer__title {
  span {
    font-family: Poppins-Bold!important;
    font-size: 16px!important;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    color: #314455;
  }
}
.el-drawer__body {
  p {
    // border: 1px solid red;
    font-family: Poppins;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #314455;
    text-align: left;
    padding: 0 36px 0;
  }
}


.pricings{
    .el-tabs--border-card{
      border: none;
      box-shadow:none;
      .el-tabs__header{
        color:#062440 !important;
        height: 56px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom:none;
        background-color: #FFF !important;
        gap: 12px;
      }
    }
  
    .el-tabs__nav-wrap .is-top{
      border: 1px solid #F2F3F5;
      background: #F7F8FA;
      padding: 4px;
      border-radius:4px;
    }
    .el-tabs__nav-scroll{
      overflow:unset;
      width:fit-content;
    }
    .el-tabs__nav{
      gap: 12px;
    }
    .el-tabs__nav .is-top{
      display:flex;
      justify-content: center;
      align-items:center;
      height: fit-content;;
      min-height: 44px;
      min-width: 100px;
      max-width: 150px;
    }
    .is-top{
      display:flex;
      justify-content:center;
      align-items:center;
      margin: 0;
      padding: 10px 12px;
    }
    .is-active{
      display:flex;
      justify-content:center;
      align-items:center;
      background-color: #1890FF !important;
      color:#FFFFFF !important;
    }
    .el-tabs__item{
      color: #67788C;
      border-radius: 4px;
      font-weight: 500;
      font-size: 12px;
      line-height: 18px;
      >span {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      .save-badge {
        font-family: 'Poppins';
        font-size: 12px;
        font-weight: 600;
        line-height: 16.5px;
        padding: 4px 12px;
        border-radius: 9999px;
        background: #DCF5E7;
        color: #0E9979;
        text-transform: uppercase;     
      }
    }
    .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active{
      background-color: #FFF !important;
      color: #062440 !important;
      border-radius: 4px;
      border: 1px solid #E5E6EB;
      >span {
        color: #062440 !important;
      }
    }
}
</style>
